module.exports = __webpack_public_path__ + "UX30b.png?41b002d069812267508469b44afb6fc2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX30b.png
// module id = 80
// module chunks = 0